// import React from "react";

// import untagPersonsFromMovieListService from '../../Services/Mutations/unTagPersonsFromMovieListService'
import UpdateMovieListService from '../../Services/Mutations/UpdateMovieListService'
// import TagpersonsToMovie from './TagpersonsToMovie'
import UpdateMovieListData from './UpdateMovieListData'

export default async function SubmitEditList(data, clearAll) {
  const {
    createListInput,
    selectedMovieOrPersonData,
    // allTaggedPersons,
    // initialAllTaggedPersons,
    // editMode,
  } = data

  const upateMovieListInput = {
    PK: 'movieLists',
    title_En: createListInput.title_En,
    title_Te: createListInput.title_Te,
    description_En: createListInput.description_En,
    description_Te: createListInput.description_Te,
    SK: createListInput.movieListID,
    movieListImage: createListInput.movieListImage ? createListInput.movieListImage : '',
  }
  try {
    const response = await UpdateMovieListService(upateMovieListInput) // end of UpdateMovieListService

    if (response.statusCode === 'M201') {
      if (selectedMovieOrPersonData.length >= 1) {
        const updateMovieListData = await UpdateMovieListData(
          createListInput.movieListCategory,
          createListInput.movieListID,
          selectedMovieOrPersonData,
        )

        // const PersonIDSarrays = allTaggedPersons.map(persons =>
        //   persons.map(moviepersoninfo => moviepersoninfo.personID),
        // )
        // const PersonIDS = PersonIDSarrays.flat(1)
        if (
          updateMovieListData.statusCode === 'M207'
          //  && PersonIDS.length === 0
        ) {
          setTimeout(() => {
            // sendLoadSpinner(false)
            clearAll(createListInput.movieListID)
          }, 3000)
        }

        // if (updateMovieListData.statusCode === 'M207' && PersonIDS.length > 0) {
        //   TagpersonsToMovie(
        //     { randomId: createListInput.movieListID, allTaggedPersons, editMode },
        //     clearAll,
        //   )
        // }

        // // find the values that are in initialAllTaggedPersons but not in allTaggedPersons
        // const alltaggedpersonsTemp = allTaggedPersons.flat(1)
        // const personsnotintag = initialAllTaggedPersons.filter(
        //   person => !alltaggedpersonsTemp.some(person2 => person === person2),
        // )
        // const untagPersonsIds = personsnotintag.map(e => e.personID)

        // if (untagPersonsIds.length > 0) {
        //   untagPersonsFromMovieListService({
        //     movieListID: createListInput.movieListID,
        //     personIDs: untagPersonsIds,
        //   })
        // }

        // setTimeout(() => {
        //   if (editMode === true) {
        //     // sendLoadSpinner(false)
        //     clearAll()
        //   }
        // }, 3000)
      }
    }
  } catch {} // end of try/catch
}
